import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
document.addEventListener('DOMContentLoaded', function() {
    // 获取所有导航链接和章节
    const sections = document.querySelectorAll('.section');
    const progressDots = document.querySelectorAll('.progress-dot');
    
    // 设置Intersection Observer来检测章节进入视口
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.8
    };
    
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // 获取当前可见章节的ID
                const currentSectionId = entry.target.id;
                
                // 为对应导航链接添加active类
                const correspondingNavLink = document.querySelector(`.nav-link[href="#${currentSectionId}"]`);
                if (correspondingNavLink) {
                    correspondingNavLink.classList.add('active');
                }
                
                // 更新进度指示器
                progressDots.forEach(dot => {
                    dot.classList.remove('active');
                    if (dot.dataset.section === currentSectionId) {
                        dot.classList.add('active');
                    }
                });
                
                // 更新章节的active状态
                sections.forEach(section => {
                    section.classList.remove('active');
                });
                entry.target.classList.add('active');
            }
        });
    }, observerOptions);
    
    // 开始观察每个章节
    sections.forEach(section => {
        observer.observe(section);
    });
    
    // 为进度指示器添加点击事件
    progressDots.forEach(dot => {
        dot.addEventListener('click', function() {
            const sectionId = this.dataset.section;
            const targetSection = document.getElementById(sectionId);
            
            if (targetSection) {
                targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
    
});

 $(window).on('scroll', function() {
    var scrollPosition = $(window).scrollTop(); // 获取当前滚动位置
    var modulePosition = $('.news .content').offset().top; // 获取目标模块的顶部位置
    var windowHeight = $(window).height(); // 获取视口高度（可选，用于更复杂的检测）
    // 检查是否滚动到了模块的顶部或底部（根据需要选择）
    if (scrollPosition >= modulePosition ) { // 到达顶部（可根据需要调整距离）
        $(".news .progress-indicator").addClass("fixed");
    }else {
        $(".news .progress-indicator").removeClass("fixed");
    }
});


var swiper1 = new Swiper(".event-swiper .mySwiper", {
    navigation: {
        nextEl: ".event-swiper .swiper-button-next",
        prevEl: ".event-swiper .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30, 
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10, 
      }
    }  
}); 